import React, { useEffect, useState } from 'react'

import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	FormGroup,
	Input,
	Row,
	Col,
	Label,
	FormFeedback,
} from "reactstrap";

import useForm from "../../formValidator/userForm";
import "./styles.css";

import Loader from '../../components/Loader'

import { CAMPAIGN } from '../../configs/urls'
import { DATE_FORMATS, MONTHS } from '../../configs/constant'
import { getApi, postApi, putApi } from '../../services/api'
import { useHistory } from 'react-router-dom'
import DatePicker from 'reactstrap-date-picker'
import moment from 'moment';

const CampaignOperations = (props) => {

	const [isRequesting, setIsRequestig] = useState(false)
	const [actionTitle, setActionTitle] = useState('Add Campaign')
	const history = useHistory()
	const [selectedMonth, setSelectedMonth] = useState(MONTHS[new Date().getMonth()])

	useEffect(() => {
		if (props.match && props.match.params) {
			if (!props.match.params.campaign_id) {
				updateSingleKey('date', new Date().toISOString())
			} else {
				setActionTitle('Update Campaign')

				setIsRequestig(true);
				const url = `${CAMPAIGN}/${props.match.params.campaign_id}`
				getApi(url)
					.then((res) => {
						params.name = res.data.name
						params.date = res.data.date
					}, (err) => {
						console.log(err);
					}).finally(() => {
						setIsRequestig(false);
					})

			}
		}
	}, [])

	const validate = (values) => {
		let errors = {};

		if (!values.date) {
			errors.date = "Date is required";
		}

		return errors;
	};

	const saveUpdateDepartment = () => {
		setIsRequestig(true);
		params.name = `${selectedMonth}-${moment(params.date).format(DATE_FORMATS.DATE_ONLY_FORMAT)}`
		if (props.match && props.match.params && props.match.params.campaign_id) {
			putApi(`${CAMPAIGN}/${props.match.params.campaign_id}`, params).then((res) => {
				history.goBack()
			}, () => {

			}).finally(() => {
				setIsRequestig(false);
			});
		} else {
			postApi(CAMPAIGN, params)
				.then(
					(res) => {
						history.goBack()
					},
					(err) => { }
				)
				.finally(() => {
					setIsRequestig(false);
				});
		}
	}

	const setSelctedMonthAndDate = (e) => {
		setSelectedMonth(e.target.value)
		const year = new Date().getFullYear()
		const date = new Date().getDate()
		const month = MONTHS.indexOf(e.target.value)
		const fullDate = `${date}-${month}-${year}`

		updateSingleKey('date', new Date(fullDate).toISOString())
	}

	const { params, errors, handleChange, handleSubmit, updateSingleKey } = useForm(
		saveUpdateDepartment,
		validate
	);

	return (
		<div className="content">
			<Loader isLoading={isRequesting} />
			<form onSubmit={handleSubmit}>
				<Card className="card-user">
					<CardHeader>
						<CardTitle tag="h5">{actionTitle}</CardTitle>
					</CardHeader>
					<hr />
					<CardBody>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<label>Month</label>
									<Input
										type="select"
										name="month"
										value={selectedMonth}
										onChange={(e) => setSelctedMonthAndDate(e)}
									>
										{
											MONTHS.map(month => (
												<option key={month} value={month}>{month}</option>
											))
										}
									</Input>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="date">Date</Label>
									<DatePicker
										dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
										value= {params.date}
										showClearButton={false}
										invalid={errors.date && errors.date.length > 0 ? true : false}
										onChange= {(value, f) => { updateSingleKey('date', value)}} />
									<FormFeedback>{errors.date}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<div className="update ml-auto mr-auto">
								<Button
									className="btn-round"
									color="primary"
									type="submit"
								>
									{actionTitle}
								</Button>
							</div>
						</Row>
					</CardBody>
				</Card>
			</form>
		</div>
	)
}

export default CampaignOperations